import { memo, useEffect, useState } from 'react';
import Table from '../../../components/Table/Table';
import { pendingScrowsFetchAction } from '../../../store/fetchActions/pendingScrowsActions';
import { useDispatch, useSelector } from 'react-redux';
import Filter from '../../../components/Filter/Filter';
import { scrowFetchAction, scrowFetchActionByCnpj } from '../../../store/fetchActions/scrowsActions';
import SelectOptions from '../../../components/SelectOptions';
import { ImSearch } from 'react-icons/im';
import Button from '../../../components/Button/Button';
import { useForm } from 'react-hook-form';
import formatCPF from '../../../utils/functions/formatCPF';
import formatCNPJ from '../../../utils/functions/formatCNPJ';
import { CircularProgress } from '@material-ui/core';
import { LoadingContainer } from '../styles/GerenciarScrows.styles';
import { FirstFilterLine, SecondFilterLine } from '../../../components/Filter/Filter.styles';
import useCallFilter from '../../../utils/hooks/useCallFilter';
import ModalPendentesPj from '../components/Modals/ScrowsPendentesPj';
import { useTheme } from 'styled-components';
import DatePicker from '../../../components/DateInput';
import TextField from '../../../components/TextField';
import moment from 'moment';
import { pagesOptions } from '../../../utils/constant/index';
import ModalDeniedScrow from '../components/Modals/DeniedScrow';
import dayjs from 'dayjs';

function ScrowsPendentes({ value, index }) {
  const theme = useTheme();
  const dispatch = useDispatch();
  const status = 4; // Pendente

  const [isModalInfoOpen, setIsModalInfoOpen] = useState(false);
  const [isModalDenyOpen, setIsModalDenyOpen] = useState(false);
  const [filterData, setFilterData] = useState('');
  const [userID, setUserID] = useState();
  const [dateInicial, setDateInicial] = useState(null);
  const [dateFinal, setDateFinal] = useState(moment().format('YYYY-MM-DD'));
  const [filter, setFilter] = useState({
    SEARCH: '',
    DATA_INICIAL: '',
    DATA_FINAL: '',
    LIMIT: 10,
    PAGE: 1,
  });

  const { handleSubmit, control, reset } = useForm({});

  useCallFilter(filterData, setFilter, pendingScrowsFetchAction, value, index);

  const filterTable = (data) => {
    data.DATA_INICIAL = dateInicial;
    data.DATA_FINAL = dateFinal;
    setFilterData(data);
  };

  const { scrowsData, scrowsInfo } = useSelector((state) => state.scrow);

  useEffect(() => {
    dispatch(pendingScrowsFetchAction(filter));
  }, [filter.PAGE]);

  const {
    pendingScrowsData,
    paginationPendingScrows,
    loadingPendingScrows,
    errorPendingScrows,
    errorMessagePendingScrows,
  } = useSelector((state) => state.pendingScrows);

  const header = [
    {
      id: 'data de registro',
      name: 'DATA DE REGISTRO',
      align: 'center',
    },
    {
      id: 'CPFCNPJ',
      name: 'CPF/CNPJ',
      align: 'left',
    },
    {
      id: 'nome',
      name: 'NOME',
      align: 'left',
    },
  ];

  const body = pendingScrowsData?.map((user) => {
    return {
      data: [
        {
          info: dayjs(user.DATA_INCLUSAO).format('DD/MM/YYYY HH:mm:ss') || '-----',
          align: 'center',
        },
        {
          info: user.CPFCNPJ?.length === 11 ? formatCPF(user.CPFCNPJ) : formatCNPJ(user.CPFCNPJ),
          align: 'left',
        },
        {
          info: user.NOME,
          align: 'left',
        },
      ],
      onClick: () => inspectUser(user.CPFCNPJ),
    };
  });

  function inspectUser(id) {
    setUserID(id);
    dispatch(scrowFetchAction(id, 'willBeLoaded', status));
    dispatch(scrowFetchActionByCnpj(id, 'willBeLoaded'));
    setIsModalInfoOpen(true);
  }

  return (
    <div>
      <Filter>
        <form onSubmit={handleSubmit(filterTable)}>
          <FirstFilterLine>
            <TextField label="Nome ou CPF/CNPJ" name={'SEARCH'} width={'38.042vw'} control={control} />
            <DatePicker
              label="Data Inicial"
              value={dateInicial}
              name={'DATA_INICIAL'}
              onChange={(newValue) =>
                newValue?.$d ? setDateInicial(moment(newValue?.$d).format('YYYY-MM-DD')) : setDate('')
              }
            />
            <DatePicker
              label="Data Final"
              value={dateFinal}
              name={'DATA_FINAL'}
              onChange={(newValue) =>
                newValue?.$d ? setDateFinal(moment(newValue?.$d).format('YYYY-MM-DD')) : setDate('')
              }
            />

            <Button
              backgroundcolor={theme.colors.buttonSearch}
              width="12.153vw"
              margin={'0 1.389vw 0 0'}
              hoverbgcolor={theme.colors.buttonSearchHover}
              hovercolor={theme.colors.buttonSearchHoverText}
              mycolor={theme.colors.buttonSearchText}
              type="submit"
            >
              <ImSearch className="default-svg" size={'1.181vw'} />
              <span>Buscar</span>
            </Button>
          </FirstFilterLine>
          <SecondFilterLine>
            <h5 style={{ padding: '0 0.4vw 0 0' }}>Resultados por página</h5>
            <SelectOptions control={control} options={pagesOptions} name={'LIMIT'} initialValue={10} />
            <h5>Total de resultados: {paginationPendingScrows?.totalResult}</h5>
          </SecondFilterLine>
        </form>
      </Filter>

      {loadingPendingScrows ? (
        <LoadingContainer>
          <CircularProgress size={'5vw'} color="inherit" />
        </LoadingContainer>
      ) : (
        <Table
          error={errorPendingScrows}
          hasPagination={true}
          filter={filter}
          pagination={paginationPendingScrows}
          setFilter={setFilter}
          errorMessage={errorMessagePendingScrows}
          filterTable={filterTable}
          header={header}
          body={body}
          limit={filter.LIMIT}
        />
      )}

      {isModalInfoOpen && (
        <ModalPendentesPj
          open={isModalInfoOpen}
          index={index}
          close={() => setIsModalInfoOpen(false)}
          info={scrowsData}
          infoByCnpj={scrowsInfo}
          deny={() => setIsModalDenyOpen(true)}
        />
      )}

      {isModalDenyOpen && (
        <ModalDeniedScrow
          open={isModalDenyOpen}
          close={() => {
            setIsModalDenyOpen(false);
            setIsModalInfoOpen(false);
          }}
          info={scrowsData}
          infoByCnpj={scrowsInfo}
        />
      )}
    </div>
  );
}

export default memo(ScrowsPendentes);
